export default __webpack_public_path__ + "static/media/hidden_characters_3_each.3cd552eb.png";